<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START navbar header-->
    <div class="navbar-header">
        <a class="navbar-brand">
            <div class="brand-logo">
                <a [href]="ssoUri">
                    <img class="img-fluid" src="assets/img/brand/logo.png" height="40px" alt="App Logo" />
                </a>
            </div>
            <div class="brand-logo-collapsed">
                <a [href]="ssoUri">
                    <img class="img-fluid" src="assets/img/brand/logo-min.png" width="45" height="45px" alt="App Logo" />
                </a>
            </div>
        </a>
    </div>
    <!-- END navbar header-->
    <!-- START Left navbar-->
    <ul class="navbar-nav mr-auto flex-row">
        <li class="nav-item">
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a class="nav-link d-none d-md-block d-lg-block d-xl-block" trigger-resize="" (click)="toggleCollapsedSideabar()"
                *ngIf="!isCollapsedText()">
                <em class="fa fa-navicon"></em>
            </a>
            <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
            <a class="nav-link sidebar-toggle d-md-none" (click)="settings.layout.asideToggled =! settings.layout.asideToggled; $event.stopPropagation()">
                <em class="fa fa-navicon"></em>
            </a>
        </li>
        <!-- START User avatar toggle-->
        <li class="nav-item d-none d-md-block">
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a class="nav-link" (click)="toggleUserBlock($event)">
                <em class="icon-user"></em>
            </a>
        </li>
        <!-- END User avatar toggle-->
    </ul>
    <!-- END Left navbar-->
    <!-- START Right Navbar-->
    <ul class="navbar-nav flex-row">
        <!-- Search icon - Disabled by now, maybe in future -->
        <!-- <li class="nav-item"  placement="bottom" tooltip="Search">
            <a class="nav-link" (click)="openNavSearch($event)">
                <em class="icon-magnifier"></em>
            </a>
        </li> -->
        <!-- Fullscreen (only desktops)-->
        <li class="nav-item d-none d-md-block" placement="bottom" tooltip="Fullscreen">
            <a class="nav-link" #fsbutton (click)="toggleFullScreen($event)">
                <em class="fa fa-expand"></em>
            </a>
        </li>
        <!-- START Alert menu-->
        <li class="nav-item dropdown dropdown-list" placement="bottom" tooltip="Notifications" dropdown>
            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
                <em class="icon-bell"></em>
                <span class="badge badge-danger">1</span>
            </a>
            <!-- START Dropdown menu-->
            <app-notifications></app-notifications>
            <!-- END Dropdown menu-->
        </li>
        <!-- END Alert menu-->
        <!-- START Offsidebar button-->
        <li class="nav-item" placement="bottom" tooltip="Settings">
            <a class="nav-link" (click)="toggleOffsidebar(); $event.stopPropagation()">
                <em class="icon-settings"></em>
            </a>
        </li>
        <!-- END Offsidebar menu-->
        <!-- Leave icon-->
        <li class="nav-item" placement="bottom" tooltip="Log out!">
            <a class="nav-link" (click)="logout()">
                <em class="icon-logout"></em>
            </a>
        </li>
    </ul>
    <!-- END Right Navbar-->

    <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

</nav>
<!-- END Top Navbar-->